// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";
import { useState } from "react";

import { mdiCog } from "@mdi/js";
import { Popover } from "antd";

import { ToolbarButton } from "components/base";

import XdaSettingsOptions from "./XdaSettingsOptions";

interface XdaSettingsToggleProps {
  availablePlays: string[];
  isLoading: boolean;
  noWellsAndSticks: boolean;
}
function XdaSettingsToggle({
  availablePlays,
  isLoading,
  noWellsAndSticks
}: XdaSettingsToggleProps) {
  const [visible, setVisible] = useState(false);

  return (
    <Popover
      content={
        <XdaSettingsOptions
          availablePlays={availablePlays}
          isLoading={isLoading}
          noWellsAndSticks={noWellsAndSticks}
        />
      }
      trigger="click"
      placement="bottomRight"
      open={visible}
      onOpenChange={(v) => setVisible(v)}>
      <ToolbarButton
        icon={<Icon path={mdiCog} size={1.4} />}
        isMenuButton={true}
        active={false}
        overflowLabel="Settings"
        tooltipText="XDA Settings"
        styleKey="xdaToolbar"
      />
    </Popover>
  );
}

export default XdaSettingsToggle;
